module.exports = __webpack_public_path__ + "img/xg2.ea254ccb.svg";